<template>
    <tr :class="`${isDeleteRequested || reassignInProgress || viewingTaskDetails ? 'edit-row' : ''}`">
        <td>
            <a
                href="javascript:void(0);"
                @click="handleTaskClick(task)"
                :class="`text-${taskStatusNameColor(task.Status)}`"
                ><EmptyTextHandler :text="task.TaskName"
            /></a>
        </td>
        <td>
            <span
                :class="`task-status badge badge-pill badge-outline-${taskStatusNameColor(task.Status)} text-align-left`"
            >
                {{ task.Status }}
            </span>
        </td>
        <td>
            <EmptyTextHandler :text="formatDate(task.StartDate, 'MM/DD/YYYY')" />
        </td>
        <td>
            <EmptyTextHandler :text="formatDate(task.EndDate, 'MM/DD/YYYY')" />
        </td>
        <td>
            <a href="javascript:void(0);" @click="handleEmployeeNameClick(task)">
                <EmptyTextHandler :text="getEmployeeName(task)" exceptionMessage="Unassigned"></EmptyTextHandler>
            </a>
        </td>
        <td>
            <EmptyTextHandler text="" />
        </td>
        <td
            v-if="
                !isDeleteRequested &&
                !downloadInProgress &&
                !printingInProgress &&
                !reassignInProgress &&
                !viewingTaskDetails
            "
            class="d-flex justify-content-end align-items-center"
        >
            <button class="btn table-btn btn-outline-info" @click="downloadVisit()">
                <i class="fas fa-download"></i>
            </button>
            <button class="btn table-btn btn-outline-info" @click="printVisit()">
                <i class="fas fa-print"></i>
            </button>
            <button
                type="button"
                class="btn table-btn btn-outline-danger"
                @click="requestDeleteTask()"
                v-if="!cantDeleteOrReassignTask"
            >
                <i class="fas fa-trash-alt"></i>
            </button>
            <button
                type="button"
                class="btn px-1 py-0 ms-1 btn-outline-primary icon-size"
                data-bs-toggle="dropdown"
                id="ReferralRow__Actions${id}"
            >
                <i class="fas fa-ellipsis-h icon-size"></i>
            </button>
            <div class="dropdown-menu" aria-labelledby="ReferralRow__Actions${id}">
                <a
                    class="dropdown-item"
                    href="javascript:void(0);"
                    @click="handleReassignVisit()"
                    v-if="!cantDeleteOrReassignTask"
                >
                    Reassign
                </a>
                <a class="dropdown-item" href="javascript:void(0);" @click="handleViewTaskDetails()"> Task Details </a>
            </div>
        </td>
        <td colspan="4" v-if="isDeleteRequested">
            <TablePrompt
                ok-text="delete"
                name="Task"
                :isInProgress="isDeleteInProgress"
                :ok="deleteTask"
                :cancel="cancelDeleteTask"
            />
        </td>
        <td v-if="downloadInProgress" colspan="4">
            <span class="text-primary">
                <i class="fas fa-download animated slow flash infinite mr-1"></i>
                <b>Download In Progress...</b></span
            >
        </td>
        <td v-if="printingInProgress" colspan="4">
            <span class="text-primary">
                <i class="fas fa-print animated slow flash infinite mr-1"></i> <b>Printing In Progress...</b></span
            >
        </td>
        <td v-if="reassignInProgress" colspan="4">
            <i>Reassigning In Progress</i>
        </td>
        <td v-if="viewingTaskDetails" colspan="4">
            <i>Viewing Task Details</i>
        </td>
    </tr>
    <tr v-if="reassignInProgress" class="edit-row">
        <td :colspan="columns" class="p-3 edit">
            <FormSection :fullHeight="false" :applicationId="task.Application">
                <template #content>
                    <section class="px-5 py-2 d-flex flex-column text-center text-primary" v-if="isSaving">
                        <i class="fas fa-exchange-alt fa-7x animated slow flash infinite"></i>
                        <span class="mt-1">
                            <b>Save In Progress...</b>
                        </span>
                    </section>
                    <div class="d-flex flex-column align-items-center p-5" v-else>
                        <span class="shimmer-loading" v-if="loadingUsers"></span>
                        <TypeaheadInput
                            v-else
                            class="w-30"
                            :getData="employeeListFilter"
                            :value="scheduleEmployee"
                            v-on:valueChanged="changescheduleEmployee"
                            placeholder="Type to Select User"
                            :show-all-by-default="true"
                            :open-on-focus="true"
                            dropdown-menu-class="custom-menu"
                        />
                    </div>
                </template>
            </FormSection>
            <div class="text-center pt-3" v-if="!isSaving">
                <button type="button" class="btn btn-primary btn-md" @click="reassignVisit()">Save</button
                ><button type="button" class="btn btn-outline-secondary btn-md ms-2" @click="handleCancelReassign()">
                    Cancel
                </button>
            </div>
        </td>
    </tr>
    <tr v-if="viewingTaskDetails" class="edit-row">
        <td :colspan="columns" class="p-3 edit">
            <template v-if="isSavingDetails">
                <div class="p-5 d-flex flex-column text-center text-primary">
                    <i class="fa fa-spinner fa-spin font-size-5xl me-2 animated slow flash infinite"></i>
                    <strong class="mt-1">
                        <b>Saving...</b>
                    </strong>
                </div>
            </template>
            <VisitDetailsHosPal
                v-else
                :employee-list="employeeList"
                :visitDetails="task"
                v-model:isSaving="isSavingDetails"
                :reassign="reassignVisit"
                :cancel="cancelViewTaskDetails"
                :ok="savedTaskDetails"
            />
        </td>
    </tr>
</template>

<script lang="ts" src="./HosPalTaskRow.ts"></script>
